import * as React from "react";
import * as questionIds from "@teamprevent/common/questionnaires/questionnaireConfig/genericCase/questionIds";
import { ContextAwareProgressBarQuestionnaireSection } from "@teamprevent/common/questionnaires/components/ContextAwareProgressBarQuestionnaireSection";
import { QuestionConfig, getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { TextQuestion, } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";
import { DropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/DropdownQuestion";

import { QuestionAnswer } from "@teamprevent/common/questionnaires/model";

import { HrRepresentative } from "@teamprevent/common/hrRepresentatives/models";

import { purchaseOrderNumberValidator } from "@teamprevent/common/ohCase/validators/purchaseOrderNumberValidator";

import { lineManagerHrSectionId, totallyConfidentialAnswer } from "../GenericCaseForm";

interface Props {
    questionConfigs: QuestionConfig[];
    hrRepresentatives: HrRepresentative[];
    currentUser?: { name: string; id: string; email: string; mobilePhone?: string; roles: string[] };
    readonly: boolean;
    getAnswerToQuestionWithId(id: string): QuestionAnswer;
    changeHrRepresentative(answer: QuestionAnswer): void;
    getQuestionMandatoryConfig(questionId: string, defaultValue: boolean): boolean;
}

export const ManagerHrSection: React.FunctionComponent<Props> = (
    {
        questionConfigs,
        currentUser,
        hrRepresentatives,
        readonly,
        getAnswerToQuestionWithId,
        changeHrRepresentative,
        getQuestionMandatoryConfig
    }) => {

    const hrRepresentativesOptions = React.useMemo(() => {
        return hrRepresentatives?.map(gct => ({ text: gct.name, value: gct.id }));
    }, [hrRepresentatives]);

    return (
        <ContextAwareProgressBarQuestionnaireSection title="Manager/HR Details" id={lineManagerHrSectionId}>
            <TextQuestion
                questionConfig={({ id: questionIds.LineManagerId, questionText: "" })}
                hidden
                readonly
                answer={currentUser?.id}
            />
            <TextQuestion
                questionConfig={getQuestionConfig(questionConfigs, questionIds.LineManagerName)}
                answer={currentUser?.name}
                readonly
            />
            <TextQuestion
                questionConfig={getQuestionConfig(questionConfigs, questionIds.LineManagerEmail)}
                readonly
                answer={currentUser?.email}
            />
            <TextQuestion
                questionConfig={getQuestionConfig(questionConfigs, questionIds.LineManagerPhone)}
                answer={currentUser?.mobilePhone ?? ""}
                readonly
            />
            {(getAnswerToQuestionWithId(questionIds.TotallyConfidential) !== totallyConfidentialAnswer) &&
                <DropdownQuestion
                    questionConfig={({ ...getQuestionConfig(questionConfigs, questionIds.HrName), id: "HrId" })}
                    options={hrRepresentativesOptions}
                    mandatory={true}
                    readonly={readonly}
                    onAnswerChange={changeHrRepresentative}
                />
            }
            {(getAnswerToQuestionWithId(questionIds.TotallyConfidential) !== totallyConfidentialAnswer ||
                ( getAnswerToQuestionWithId(questionIds.HrName))) &&
                <>
                    <TextQuestion
                        questionConfig={getQuestionConfig(questionConfigs, questionIds.HrEmail)}
                        readonly={readonly}
                        hideDivider={true}
                    />
                </>
            }
            <TextQuestion
                hideDivider
                questionConfig={getQuestionConfig(questionConfigs, questionIds.PurchaseOrderNumber)}
                readonly={readonly}
                mandatory={getQuestionMandatoryConfig(questionIds.PurchaseOrderNumber, false)}
                validators={[purchaseOrderNumberValidator]}
            />
        </ContextAwareProgressBarQuestionnaireSection>
    );
};
